import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {ApiService} from "../../services/api.service";
import {AdList} from "../../interfaces/ad";
import {AuthenticationService} from "../../services/auth.service";
import {CursorToken} from "../../interfaces/utils";
import { KazButtonComponent } from '../kaz-button/kaz-button.component';
import { RouterLink } from '@angular/router';
import { KazCardActiveAdsComponent } from '../kaz-card-active-ads/kaz-card-active-ads.component';

@Component({
    selector: 'kaz-ads',
    templateUrl: './kaz-ads.component.html',
    styleUrls: ['./kaz-ads.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [KazButtonComponent, RouterLink, KazCardActiveAdsComponent]
})
export class KazAdsComponent implements OnInit {
  private _api = inject(ApiService);
  private _auth = inject(AuthenticationService);

  ownAds: AdList | null = null;

  nextToken: CursorToken = "@start";

  async ngOnInit() {
    await this.getActiveAds()
  }

  async getActiveAds() {
    try {
      this.ownAds = await this._api.getActiveAdList(this.nextToken, 24);
    } catch (err) {

    }
  }

  refreshActiveAds(){
    this.getActiveAds().then();
  }
}
